import { useEffect, useState } from "react";

import { Typography } from "@mui/material";

import styles from "./LoadingEllipsis.module.css";
import type { LoaderProps } from "./types";

const srOnly: React.CSSProperties = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0",
};

const textStyle = { marginBottom: "16px", display: "flex", justifyContent: "center" };

const LoadingEllipsis = ({ text, showOnMount = false }: LoaderProps) => {
  const [isLoading, setIsLoading] = useState(showOnMount);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsLoading(true), 200);

    return () => clearTimeout(timeoutId);
  }, []);

  const loadingText = text || "Loading...";

  return (
    <>
      {isLoading && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
          role="status"
          data-testid="loading-ellipsis"
        >
          {/* {children} */}
          <div style={text ? textStyle : srOnly}>
            <Typography
              variant="body1"
              // color="gray"
              sx={{ marginBottom: "16px", textAlign: "center" }}
            >
              {loadingText}
            </Typography>
          </div>
          <div style={{ display: "flex" }}>
            <span className={`${styles.ellipsis} ${styles.first}`}></span>
            <span className={`${styles.ellipsis} ${styles.second}`}></span>
            <span className={`${styles.ellipsis} ${styles.third}`}></span>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingEllipsis;
